import { render } from "./FpImage.vue?vue&type=template&id=d79c1418"
import script from "./FpImage.vue?vue&type=script&lang=js"
export * from "./FpImage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__